import SelectedPlace  from './SelectedPlace';

export default SelectedPlace;
